import { SPLIT_CASE_CONDITION_FULL, SPLIT_CASE_CONDITION_PARTIAL } from '_utils/constant'
import { useCallback, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useLocation } from 'react-router-dom'
import { Modal } from 'reactstrap'
import useDebounce from '../../../../hooks/useDebounce'
import InputProduct from '../../../../pages/Event/components/InputProduct'

const ModalSplitCasePurchase = (props) => {
  const { isOpen, toggle, onOk, productIndex, watch: mainWatch, setValue: mainSetValue } = props

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    control,
    formState: { errors },
  } = useForm({
    mode: 'all',
  })

  const price = mainWatch(`products.${productIndex}.price`)
  const initialCostPerItem = mainWatch(`products.${productIndex}.splitCasePurchase.costPerItem`)
  const itemsPerCase = watch('itemsPerCase')
  const fulfillCondition = watch('fulfillCondition')
  const debouncedItemsPerCase = useDebounce(itemsPerCase, 1000)

  useEffect(() => {
    if (isOpen) {
      const mainData = mainWatch(`products.${productIndex}.splitCasePurchase`) || {}
      reset({
        description: mainData.description || '',
        itemsPerCase: mainData.itemsPerCase || '',
        costPerItem: mainData.costPerItem || '',
        minItemOrder: mainData.minItemOrder || 1,
        fulfillCondition: mainData.fulfillCondition || SPLIT_CASE_CONDITION_FULL,
        acknowledgementRequiredPayAfter:
          mainData.acknowledgementRequiredPayAfter ??
          mainData.fulfillCondition === SPLIT_CASE_CONDITION_FULL,
      })
    }
  }, [isOpen, mainWatch, productIndex, reset])

  const location = useLocation()
  const [hideCheckbox, setHideCheckbox] = useState(false)
  const [isCostPerItemTouched, setIsCostPerItemTouched] = useState(false)
  const [isItemsPerCaseTouched, setIsItemsPerCaseTouched] = useState(false)

  const showCheckbox = !hideCheckbox && fulfillCondition === SPLIT_CASE_CONDITION_FULL

  useEffect(() => {
    if (isOpen) {
      setIsCostPerItemTouched(false)
      setIsItemsPerCaseTouched(false)
    }
  }, [isOpen])

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    setHideCheckbox(!!params.get('id'))
  }, [location.search])

  useEffect(() => {
    setValue('acknowledgementRequiredPayAfter', fulfillCondition === SPLIT_CASE_CONDITION_FULL)
  }, [fulfillCondition, setValue])

  useEffect(() => {
    // Bỏ qua nếu đã có sẵn cost từ DB VÀ người dùng chưa chạm vào itemsPerCase
    if (initialCostPerItem !== null && initialCostPerItem !== undefined && initialCostPerItem !== '') {
      if (!isItemsPerCaseTouched) {
        return
      }
    }

    if (
      isOpen &&
      !isCostPerItemTouched &&
      debouncedItemsPerCase &&
      !isNaN(Number(debouncedItemsPerCase)) &&
      Number(debouncedItemsPerCase) > 0 &&
      price &&
      !isNaN(Number(price)) &&
      Number(price) > 0
    ) {
      const cost = Number(price) / Number(debouncedItemsPerCase)
      setValue('costPerItem', Number(cost.toFixed(2)))
    }
  }, [
    isOpen,
    debouncedItemsPerCase,
    price,
    setValue,
    isCostPerItemTouched,
    isItemsPerCaseTouched,
    initialCostPerItem,
  ])

  const onConfirm = useCallback(
    (data) => {
      const formattedData = {
        ...data,
        itemsPerCase: data.itemsPerCase === '' ? null : Number(data.itemsPerCase),
        costPerItem: data.costPerItem === '' ? null : Number(data.costPerItem),
        minItemOrder: data.minItemOrder === '' ? null : Number(data.minItemOrder),
      }
      mainSetValue(`products.${productIndex}.splitCasePurchase`, formattedData)
      if (onOk) onOk()
      else toggle()
    },
    [mainSetValue, productIndex, onOk, toggle]
  )

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered className='product-setting'>
      <div className='container'>
        <p className='c-txt-org text-center'>Split Case Purchase</p>
        <div className='c-form'>
          <div className='form-group'>
            <div className='row'>
              <label className='col-5 align-self-center'>Items per case/carton:</label>
              <div className='col-7'>
                <Controller
                  control={control}
                  name='itemsPerCase'
                  rules={{
                    required: 'Required',
                    min: { value: 1, message: 'Must be at least 1' },
                  }}
                  render={({ field }) => (
                    <InputProduct
                      {...field}
                      type='number'
                      className={`form-control split-case ${errors?.itemsPerCase ? 'is-error' : ''}`}
                      onChange={(e) => {
                        setIsItemsPerCaseTouched(true)
                        field.onChange(e)
                      }}
                      error={errors?.itemsPerCase?.message}
                    />
                  )}
                />
              </div>
              <label className='col-5 align-self-center'>Cost per item:</label>
              <div className='col-7'>
                <Controller
                  control={control}
                  name='costPerItem'
                  render={({ field }) => (
                    <InputProduct
                      {...field}
                      type='number'
                      className={`form-control ${errors?.costPerItem ? 'is-error' : ''}`}
                      onChange={(e) => {
                        setIsCostPerItemTouched(true)
                        field.onChange(e)
                      }}
                      error={errors?.costPerItem?.message}
                    />
                  )}
                />
              </div>
              <label className='col-5 align-self-center'>Minimum item order:</label>
              <div className='col-7'>
                <InputProduct
                  type='number'
                  className={`form-control ${errors?.minItemOrder ? 'is-error' : ''}`}
                  register={register('minItemOrder', {
                    required: 'Required',
                    min: { value: 1, message: 'Must be at least 1' },
                  })}
                  error={errors?.minItemOrder?.message}
                />
              </div>

              <div className='col-12 mt-3'>
                <div className='form-check'>
                  <input
                    type='radio'
                    value={SPLIT_CASE_CONDITION_FULL}
                    className='form-check-input'
                    {...register('fulfillCondition')}
                  />
                  <label className='form-check-label'>
                    Fulfill only when a full case is ordered
                  </label>
                </div>
                <div className='form-check'>
                  <input
                    type='radio'
                    value={SPLIT_CASE_CONDITION_PARTIAL}
                    className='form-check-input'
                    {...register('fulfillCondition')}
                  />
                  <label className='form-check-label'>Fulfill even if the case is incomplete</label>
                </div>
              </div>
              <div className='col-12'>
                <hr className='my-3 border-dark' />
              </div>
              <div className='d-flex gap-3'>
                {showCheckbox && (
                  <>
                    <input
                      id='autoPaymentAfter'
                      type='checkbox'
                      className='custom-control-checkbox'
                      checked={true}
                      readOnly
                      disabled
                      style={{ pointerEvents: 'none' }}
                    />
                    <label className='custom-control-label' htmlFor='autoPaymentAfter'>
                      I acknowledge that enabling the split case option—fulfilled only when a full
                      case is ordered—will automatically activate the &apos;Pay Later&apos; option.
                    </label>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className='row mt-3'>
          <div className='col-6 m-auto'>
            <button className='btn btn--org btn--org02' onClick={handleSubmit(onConfirm)}>
              OK
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ModalSplitCasePurchase
